import * as React from 'react';

function KamMultiple(props) {
  return (
    <svg
      height={21.471}
      style={{ display: 'block' }}
      viewBox="0 0 27.804 21.471"
      width={27.804}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g data-name="picto-KAM suivi">
        <g
          data-name="Groupe 1568"
          fill="none"
          stroke="#18191b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.2}
        >
          <path
            d="M18.125 20.871a16.6 16.6 0 00-1.9-6.319 5.7 5.7 0 00-1.9-1.943c-1.9-1.188-8.064-1.038-9.92 0a6.528 6.528 0 00-2.709 3.677 26.443 26.443 0 00-1.092 4.585zM12.811 5.919a3.421 3.421 0 11-3.436-3.408h.016a3.414 3.414 0 013.42 3.408z"
            data-name="Trac\xE9 218"
          />
          <path d="M5.876 20.87v-4.828" data-name="Ligne 231" />
          <path d="M12.812 20.87v-4.828" data-name="Ligne 232" />
        </g>
        <g data-name="picto-KAM">
          <g
            data-name="Groupe 1568"
            fill="none"
            stroke="#18191b"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.2}
          >
            <path
              d="M17.471 17.556h9.733a15.886 15.886 0 00-1.824-6.049 5.45 5.45 0 00-1.818-1.86c-1.819-1.138-7.721-.994-9.5 0a9.572 9.572 0 00-2.154 2.269m9.87-8.388A2.94 2.94 0 1118.826.6h.014a2.933 2.933 0 012.94 2.928z"
              data-name="Trac\xE9 218"
            />
            <path d="M22.117 17.556v-4.622" data-name="Ligne 232" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default KamMultiple;
